import type { HTMLAttributes, ReactNode, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';

import { ClassNames } from '@/shared/classNames';

type WithChildren<T> = T & {
  children: ReactNode;
};

export const TableShell = ({ children, className, ...properties }: WithChildren<HTMLAttributes<HTMLDivElement>>) => (
  <div className={ClassNames('border-line bg-panel overflow-x-auto rounded-lg border', className)} {...properties}>
    {children}
  </div>
);

export const Table = ({ children, className, ...properties }: WithChildren<TableHTMLAttributes<HTMLTableElement>>) => (
  <table className={ClassNames('w-full min-w-max text-left text-sm', className)} {...properties}>
    {children}
  </table>
);

export const TableHeader = ({ children, className, ...properties }: WithChildren<HTMLAttributes<HTMLTableSectionElement>>) => (
  <thead className={ClassNames('bg-sidebar text-muted text-xs font-semibold tracking-wide uppercase', className)} {...properties}>
    {children}
  </thead>
);

export const TableBody = ({ children, className, ...properties }: WithChildren<HTMLAttributes<HTMLTableSectionElement>>) => (
  <tbody className={className} {...properties}>
    {children}
  </tbody>
);

export const TableRow = ({ children, className, ...properties }: WithChildren<HTMLAttributes<HTMLTableRowElement>>) => (
  <tr className={ClassNames('border-line hover:bg-selection/45 border-t transition-colors', className)} {...properties}>
    {children}
  </tr>
);

export const TableHead = ({ children, className, ...properties }: WithChildren<ThHTMLAttributes<HTMLTableCellElement>>) => (
  <th className={ClassNames('px-3 py-2 font-medium', className)} {...properties}>
    {children}
  </th>
);

export const TableCell = ({ children, className, ...properties }: WithChildren<TdHTMLAttributes<HTMLTableCellElement>>) => (
  <td className={ClassNames('text-ink px-3 py-2.5', className)} {...properties}>
    {children}
  </td>
);
